import React, { useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useAmbient } from '../../contexts/AmbientContext';
import { useLang } from "../../contexts/LanguageContext";

export const AmbientSelector = ({ preferences, onChange }) => {
  const { t } = useLang();
  const { 
    currentTrackId, 
    volume, 
    isPlaying, 
    tracks, 
    selectTrack, 
    togglePlay, 
    updateVolume,
    setVolume,
    setCurrentTrackId,
    setIsPlaying
  } = useAmbient();

  // Inicializar el contexto con las preferencias si están disponibles y el contexto está vacío
  useEffect(() => {
    if (preferences) {
      if (preferences.ambientTrackId && currentTrackId === null) {
        setCurrentTrackId(preferences.ambientTrackId);
        setIsPlaying(true);
      }
      if (preferences.ambientVolume !== undefined && volume === 0.5) {
        setVolume(preferences.ambientVolume);
      }
    }
  }, [preferences]);

  // Notificar al padre cuando cambian los valores globales para que se sincronicen con la API
  const handleTrackSelect = (id) => {
    selectTrack(id);
    if (onChange) onChange('ambientTrackId', id);
  };

  const handleVolumeChange = (newVol) => {
    updateVolume(newVol);
    if (onChange) onChange('ambientVolume', newVol);
  };

  return (
    <div className="ambient-selector p-3">
      
      <Row className="g-2 mb-3">
        <Col xs={12}>
          <div className="d-flex flex-wrap gap-2">
            <Button 
              variant={currentTrackId === null ? "primary" : "outline-primary"}
              size="sm"
              onClick={() => handleTrackSelect(null)}
              className="rounded-pill"
            >
              {t("AMBIENT_OFF")}
            </Button>
            {tracks.map(track => (
              <Button 
                key={track.id}
                variant={currentTrackId === track.id ? "primary" : "outline-primary"}
                size="sm"
                onClick={() => handleTrackSelect(track.id)}
                className="rounded-pill d-flex align-items-center gap-1"
              >
                <span>{t(`AMBIENT_${track.id.toUpperCase()}`)}</span>
              </Button>
            ))}
          </div>
        </Col>
      </Row>

      {currentTrackId && (
        <Row className="align-items-center">
          <Col xs="auto">
            <Button 
              variant="link" 
              className="p-0 text-primary" 
              onClick={togglePlay}
            >
              <i className={`bi bi-${isPlaying ? 'pause-fill' : 'play-fill'} fs-4`}></i>
            </Button>
          </Col>
          <Col>
            <Form.Range 
              value={volume * 100} 
              onChange={(e) => handleVolumeChange(parseFloat(e.target.value) / 100)}
              min={0}
              max={100}
            />
          </Col>
          <Col xs="auto" className="text-muted small" style={{ minWidth: '35px' }}>
            {Math.round(volume * 100)}%
          </Col>
        </Row>
      )}
    </div>
  );
};
